import {
  CompletedStatusIcon,
  NewIcon,
  ReadyIcon,
  DeliveringIcon,
  RedispatchIcon,
  ArchivedIcon,
  CanceledIcon,
} from 'pages/Tracking/icons';
import classNames from 'classnames';
import styles from '../../Tracking.module.scss';
import {TrackingDeliveryStatus} from 'types/tracking';

type BannerConfig = {
  icon: JSX.Element;
  title: string;
  message: string;
};

const BANNER_CONFIG: Record<TrackingDeliveryStatus, BannerConfig> = {
  new: {
    icon: <NewIcon />,
    title: 'Order Received',
    message:
      'Your order has been received and is being prepared for processing.',
  },
  in_progress: {
    icon: <NewIcon />,
    title: 'Processing',
    message: 'Your order is being processed and will be dispatched soon.',
  },
  ready_for_dispatch: {
    icon: <ReadyIcon />,
    title: 'Ready for Dispatch',
    message:
      'Your order is ready and will be dispatched shortly. Stay tuned for updates!',
  },
  delivering: {
    icon: <DeliveringIcon />,
    title: 'On the Way',
    message: 'Your order is on its way to you!',
  },
  redispatch: {
    icon: <RedispatchIcon />,
    title: 'Redelivery Scheduled',
    message:
      'Your order is scheduled for redelivery. We will attempt delivery again soon.',
  },
  canceled: {
    icon: <CanceledIcon />,
    title: 'Delivery Canceled',
    message:
      'This delivery has been canceled. Please contact support for more information.',
  },
  completed: {
    icon: <CompletedStatusIcon />,
    title: 'Delivery Completed',
    message:
      'Your order has been successfully delivered. Thank you for choosing us!',
  },
  archived: {
    icon: <ArchivedIcon />,
    title: 'Order Archived',
    message: 'This order has been archived.',
  },
};

type Props = {
  status: TrackingDeliveryStatus;
  attempt?: number;
};

const StatusBanner = ({status, attempt}: Props) => {
  const config = BANNER_CONFIG[status];
  const {icon, title, message} = config;

  const displayTitle =
    status === 'redispatch' && attempt && attempt > 1
      ? `${title} (Attempt #${attempt})`
      : title;

  return (
    <div
      className={classNames(
        styles.statusBanner,
        styles[status.replaceAll('_', '')]
      )}
    >
      <div className={styles.statusBannerIcon}>{icon}</div>
      <h2 className={styles.statusBannerTitle}>{displayTitle}</h2>
      <p className={styles.statusBannerMessage}>{message}</p>
    </div>
  );
};

export default StatusBanner;
